import { utils } from '@dicebear/avatars';
import jdenticon from 'jdenticon/dist/jdenticon';

var schema$1 = {
  "title": "Options",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "properties": {
    "hues": {
      "title": "Hues",
      "type": "array",
      "items": {
        "type": "integer",
        "minimum": 0,
        "maximum": 360
      }
    },
    "colorLightness": {
      "title": "Color Lightness",
      "type": "array",
      "minItems": 2,
      "maxItems": 2,
      "items": {
        "type": "number",
        "minimum": 0,
        "maximum": 100
      }
    },
    "grayscaleLightness": {
      "title": "Grayscale Lightness",
      "type": "array",
      "minItems": 2,
      "maxItems": 2,
      "items": {
        "type": "number",
        "minimum": 0,
        "maximum": 100
      }
    },
    "colorSaturation": {
      "title": "Color Saturation",
      "type": "integer",
      "minimum": 0,
      "maximum": 100
    },
    "grayscaleSaturation": {
      "title": "Grayscale Saturation",
      "type": "integer",
      "minimum": 0,
      "maximum": 100
    }
  },
  "additionalProperties": false
};

// @ts-ignore
var style = {
  meta: {
    title: 'Jdenticon',
    creator: 'Daniel Mester Pirttijärvi',
    source: 'https://github.com/dmester/jdenticon',
    license: {
      name: 'MIT',
      url: 'https://github.com/dmester/jdenticon/blob/master/LICENSE'
    }
  },
  schema: schema$1,
  create: function create(_ref) {
    var prng = _ref.prng,
        options = _ref.options;
    jdenticon.config = {
      hues: options.hues,
      lightness: {
        color: options.colorLightness,
        grayscale: options.grayscaleLightness
      },
      saturation: {
        color: options.colorSaturation,
        grayscale: options.grayscaleSaturation
      }
    };
    return {
      attributes: {
        viewBox: '0 0 50 50',
        preserveAspectRatio: 'xMidYMid meet'
      },
      body: jdenticon.toSvg(prng.seed, 50, 0).replace(/<svg.*?>(.*)<\/svg>/, '$1')
    };
  }
};

/*!
 * DiceBear Jdenticon (@dicebear/avatars-jdenticon-sprites)
 *
 * Code licensed under MIT (https://github.com/dicebear/dicebear/blob/v4/packages/avatars-jdenticon-sprites/LICENSE)
 * Copyright (c) 2021 Florian Körner
 */
var create = style.create,
    meta = style.meta,
    schema = style.schema;
/** @deprecated will be removed in Version 5.0 */

var index = utils.style.createLegacyWrapper({
  create: create,
  meta: meta,
  schema: schema
});

export { create, index as default, meta, schema };
